/**
 * Created by zad on 17/4/26.
 */
import i18n from 'react-intl-universal';
import { put, call, select, take, takeLatest } from 'redux-saga/effects';
import { NoteContent } from '../constants/actionTypes';
import { getState } from '../reducers/NoteContent/NoteContentReducer';
import { CONTENT_NOT_FOUND } from '../constants/variables';
import ajax from '../utils/ajax';
import message from '../components/Message';

function* getNoteContentAsync(action) {
  const state = yield select(getState);
  const { noteId, isForce } = action;
  const content = state.getIn(['entities', noteId, 'content'], CONTENT_NOT_FOUND);
  try {
    // 如果还未获取到文章或设置isForce为true，则发起请求
    if (content === CONTENT_NOT_FOUND || isForce) {
      const { data } = yield call(ajax.getNoteContent, noteId);
      yield put({ type: NoteContent.GET_NOTE_CONTENT_SUCCESS, data, noteId });
    } else {
      yield put({ type: NoteContent.GET_NOTE_CONTENT_SUCCESS, noteId, isCache: true });
    }
  } catch (e) {
    yield put({ type: NoteContent.GET_NOTE_CONTENT_FAIL, noteId });
  }
}

function* putAudioMessageAsync(action) {
  const { noteId, params } = action;
  try {
    const { data } = yield call(ajax.putAudioMessage, noteId, params);
    yield put({ type: NoteContent.PUT_AUDIO_MESSAGE_SUCCESS, data, noteId, params });
  } catch (error) {
    yield put({ type: NoteContent.PUT_AUDIO_MESSAGE_FAIL, error, noteId });
  }
}

function* deleteAudioAsync(action) {
  const { noteId } = action;
  try {
    const { data } = yield call(ajax.deleteAudio, noteId);
    yield put({ type: NoteContent.DELETE_AUDIO_SUCCESS, data, noteId });
  } catch (error) {
    yield put({ type: NoteContent.DELETE_AUDIO_FAIL, error, noteId });
  }
}

function* getAudioUrlAsync(action) {
  const { noteId } = action;
  try {
    const { data } = yield call(ajax.getAudioUrl, noteId);
    yield put({ type: NoteContent.GET_AUDIO_URL_SUCCESS, data, noteId });
  } catch (error) {
    yield put({ type: NoteContent.GET_AUDIO_URL_FAIL, error, noteId });
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* watchGetNoteContent() {
  yield takeLatest(NoteContent.GET_NOTE_CONTENT, getNoteContentAsync);
}

export function* watchPutAudioMessageAsync() {
  yield takeLatest(NoteContent.PUT_AUDIO_MESSAGE, putAudioMessageAsync);
}

export function* watchDeleteAudio() {
  yield takeLatest(NoteContent.DELETE_AUDIO, deleteAudioAsync);
}

export function* watchGetAudioUrl() {
  yield takeLatest(NoteContent.GET_AUDIO_URL, getAudioUrlAsync);
}



// WEBPACK FOOTER //
// ./src/sagas/NoteContentSaga.js